import { useLocales } from '@shared/locales'
import { Space } from 'antd'

export const ForbiddenError = () => {
  const { t } = useLocales()

  return (
    <Space direction="vertical" className="error-page">
      <h1 className="error-page__title">{t('error.403')}</h1>
      <h2 className="error-page__description">{t('error.dont_have_access')}</h2>
    </Space>
  )
}
